import { Progress } from '@cimplico/components';
import { getFieldCount } from './store/utils';
import { WorksheetSchemaBlockProperty } from '../../../types/custom-worksheet-v2';
import { selectShowHidden } from './store/selectors';
import { useSelector } from 'react-redux';

type PropertyProgressProps = {
    property: WorksheetSchemaBlockProperty;
    textPosition?: 'left' | 'right';
};

function PropertyProgress({ property, textPosition = 'left' }: PropertyProgressProps): JSX.Element {
    const showHiddenFields = useSelector(selectShowHidden);
    const { total, completed } = getFieldCount(property, showHiddenFields);

    return (
        <div className={`flex ${textPosition === 'right' ? 'flex-row-reverse' : ''} gap-2 items-center`}>
            <Progress type="circle" percent={total === 0 ? 100 : (completed / total) * 100} size="small" />
            <p className="text-sm text-gray-600">
                {completed}/{total}
            </p>
        </div>
    );
}

export default PropertyProgress;
